import { FC } from 'react';
// 组件
import SuperAutoComplete, { SuperAutoCompleteProps } from '../SuperAutoComplete';
import SearchFormItem from './subpage/searchFormItem';
import SearchFormDisabled from './subpage/disabled';
// 方法
import { getInputPlaceholder } from '../utils/ruleUtils';
// 常量
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';

export interface SearchFormSuperAutoCompleteProps extends BaseSearchFormItemProps {
  /** superAutoComplete Props */
  superAutoCompleteProps?: SuperAutoCompleteProps;
}
/** 自动搜索+可输入 */
export const SearchFormSuperAutoComplete: FC<SearchFormSuperAutoCompleteProps> = props => {
  const {
    superAutoCompleteProps,
    form,
    isDetail,
    isTable,
    testId,
    name,
    render,
    disabledRender,
    label,
    rules,
    ...resProps
  } = props;
  return (
    <SearchFormItem
      {...resProps}
      name={name}
      label={label}
      rules={rules}
      disabled={isDetail || superAutoCompleteProps?.disabled}
    >
      {isDetail || (superAutoCompleteProps && superAutoCompleteProps.disabled) ? (
        <SearchFormDisabled
          name={name}
          form={form}
          render={render || disabledRender}
          isTable={isTable}
        />
      ) : (
        <SuperAutoComplete
          {...superAutoCompleteProps}
          placeholder={getInputPlaceholder(label, superAutoCompleteProps, rules)}
          test-id={`${testId}-${name}`}
        />
      )}
    </SearchFormItem>
  );
};

SearchFormSuperAutoComplete.displayName = SearchFormItemEnum.SearchFormSuperAutoComplete;

export default SearchFormSuperAutoComplete;
